<template>
  <div class="pt-3">
    <!--begin::Signup-->
    <div class="login-form login-signin">
      <div class="text-center">
        <h3 class="font-size-h1">{{$t('AUTH.REGISTER.TITLE')}}</h3>
        <p class="text-muted font-weight-semi-bold">
          {{$t('AUTH.REGISTER.DESC')}}
        </p>
      </div>
      <!--begin::Form-->
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
          &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</div>
        <div role="alert" v-if="errors" v-bind:class="{ show: errors.length }" class="alert fade alert-danger">
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            <span v-if="error == 'refresh'">{{$t('AUTH.TIPS.REFRESH')}}</span>
            <span v-else-if="error == 'repeat'">{{$t('AUTH.TIPS.REPEAT')}}</span>
            <span v-else-if="error == 'register'">{{$t('AUTH.TIPS.REGISTERTWO')}}</span>
            <span v-else>{{ error }}</span>
          </div>
        </div>
        <b-form-group id="example-input-group-0" label="" label-for="example-input-0" v-show="false">
          <b-form-input class="form-control form-control-solid h-auto py-5 px-6" id="example-input-0" name="example-input-0"
              v-model="$v.form.code.$model" :state="validateState('code')" aria-describedby="input-0-live-feedback" disabled></b-form-input>
        </b-form-group>
        <b-form-group id="example-input-group-1" label="" label-for="example-input-1">
          <b-form-input class="form-control form-control-solid h-auto py-5 px-6" id="example-input-1" name="example-input-1" :placeholder="$t('AUTH.INPUT.FULLNAME')"
                        v-model="$v.form.fullName.$model" :state="validateState('fullName')" aria-describedby="input-1-live-feedback"></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            {{$t('AUTH.VALIDATION.FULLNAME')}}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="example-input-group-2" label="" label-for="example-input-2">
          <b-form-input class="form-control form-control-solid h-auto py-5 px-6" id="example-input-2" name="example-input-2" :placeholder="$t('AUTH.INPUT.EMAIL')"
                        v-model="$v.form.email.$model" :state="validateState('email')" aria-describedby="input-2-live-feedback"></b-form-input>
          <b-form-invalid-feedback id="input-2-live-feedback">
            {{$t('AUTH.VALIDATION.EMAIL')}}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="example-input-group-3" label="" label-for="example-input-3">
          <b-form-input class="form-control form-control-solid h-auto py-5 px-6" id="example-input-3" name="example-input-3" :placeholder="$t('AUTH.INPUT.COMPANY')"
                        v-model="$v.form.corporation.$model" :state="validateState('corporation')" aria-describedby="input-3-live-feedback"></b-form-input>
          <b-form-invalid-feedback id="input-3-live-feedback">
            {{$t('AUTH.VALIDATION.COMPANY')}}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="example-input-group-4" label="" label-for="example-input-4">
          <b-form-input class="form-control form-control-solid h-auto py-5 px-6" id="example-input-4" name="example-input-4" :placeholder="$t('AUTH.INPUT.ADDRESS')"
                        v-model="$v.form.address.$model" :state="validateState('address')" aria-describedby="input-4-live-feedback"></b-form-input>
          <b-form-invalid-feedback id="input-4-live-feedback">
            {{$t('AUTH.VALIDATION.ADDRESS')}}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="example-input-group-5" label="" label-for="example-input-5">
          <b-form-input class="form-control form-control-solid h-auto py-5 px-6" id="example-input-5" name="example-input-5" :placeholder="$t('AUTH.INPUT.LINKMAN')"
                        v-model="$v.form.linkman.$model" :state="validateState('linkman')" aria-describedby="input-5-live-feedback"></b-form-input>
          <b-form-invalid-feedback id="input-5-live-feedback">
            {{$t('AUTH.VALIDATION.LINKMAN')}}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="example-input-group-6" label="" label-for="example-input-6">
          <b-form-input class="form-control form-control-solid h-auto py-5 px-6" type="password" id="example-input-6" name="example-input-6" :placeholder="$t('AUTH.INPUT.PASSWORD')"
                        v-model="$v.form.password.$model" :state="validateState('password')" aria-describedby="input-6-live-feedback"></b-form-input>
          <b-form-invalid-feedback id="input-6-live-feedback">
            {{$t('AUTH.VALIDATION.PASSWORD')}}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="example-input-group-7" label="" label-for="example-input-7">
          <b-form-input class="form-control form-control-solid h-auto py-5 px-6" type="password" id="example-input-7" name="example-input-7" :placeholder="$t('AUTH.INPUT.CONFIRM_PASSWORD')"
                        v-model="$v.form.rePassword.$model" :state="validateState('rePassword')" aria-describedby="input-7-live-feedback"></b-form-input>
          <b-form-invalid-feedback id="input-7-live-feedback">
            {{$t('AUTH.VALIDATION.CONFIMPASS')}}
          </b-form-invalid-feedback>
        </b-form-group>
        <div class="form-group">
          <label class="checkbox mb-0">
            <input type="checkbox" name="agree" v-model="clickFlag"/>{{$t('AUTH.REGISTER.CONDITION_TOP')}}&nbsp;
            <a href="#">{{$t('AUTH.REGISTER.CONDITION_FOOT')}}</a>&nbsp;&nbsp;
            <span></span></label>
        </div>
        <div class="form-group d-flex flex-wrap flex-center">
          <button type="submit" ref="kt_login_signup_submit" class="btn btn-primary font-weight-bold px-9 py-4 my-3 font-size-3 mx-4">{{$t('AUTH.REGISTER.SUBMIT_BUTTON')}}</button>
          <button v-on:click="$router.push('login')" class="btn btn-light-primary font-weight-bold px-9 py-4 my-3 font-size-3 mx-4">{{$t('AUTH.REGISTER.CANCEL_BUTTON')}}</button>
        </div>
      </b-form>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
<script>
import { mapState } from "vuex";
import { REGISTER } from "@/core/services/store/auth.module";
import { LOGOUTAUTH } from "@/core/services/store/auth.module";

import { validationMixin } from "vuelidate";
import { email, required, minLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "register",
  data() {
    return {
      clickFlag: true,
      form: {
        email: "",
        password: "",
        code: "ld",
        fullName: "",
        corporation: "",
        address: "",
        linkman: "",
        rePassword: "",
      }
    };
  },
  validations: {
    form: {
      code: {
        required,
      },
      fullName: {
        required,
      },
      corporation: {
        required,
      },
      address: {
        required,
      },
      linkman: {
        required,
      },
      rePassword: {
        required,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(3)
      },
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: "",
        password: "",
        code: "ld",
        fullName: "",
        corporation: "",
        address: "",
        linkman: "",
        rePassword: "",
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const password = this.$v.form.password.$model;
      const rePassword = this.$v.form.rePassword.$model;
      if (password != rePassword){
        this.$parent.openMessage("comfimPass");
        return;
      }
      if (!this.clickFlag){
        this.$parent.openMessage("consentClause");
        return;
      }
      const email = this.$v.form.email.$model;
      const code = this.$v.form.code.$model;
      const fullName = this.$v.form.fullName.$model;
      const corporation = this.$v.form.corporation.$model;
      const address = this.$v.form.address.$model;
      const linkman = this.$v.form.linkman.$model;

      // clear existing errors
      this.$store.dispatch(LOGOUTAUTH);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signup_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send register request
        this.$store.dispatch(REGISTER, {
              email: email,
              password: password,
              code: code,
              userName: fullName,
              companyName: corporation,
              contractAdress: address,
              linkman: linkman,
            }).then(() => {
              this.$parent.openMessage("success");
              this.$router.push("/");
            });

        submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
        );
      }, 2000);
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>